//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';
import styled from '@emotion/styled';

type TooltipOverflowProps = {
  items: string[];
  length?: number;
  delimeter?: string;
  tooltipPlacement?: TooltipProps['placement'];
};

const TooltipOverflow = ({ items, length = 2, tooltipPlacement = 'bottom', delimeter = ', ' }: TooltipOverflowProps) => {
  if (!items?.length) return null;

  const displayItems = items.slice(0, length);
  const overflowItems = items.slice(length, items.length);
  const overflowLength = items.length - length;

  return (
    <div>
      {displayItems.join(delimeter)}
      {overflowLength > 0 && (
        <Tooltip
          title={
            <TooltipTitleWrapper>
              {overflowItems.map((ot) => (
                <div key={ot}>{ot}</div>
              ))}
            </TooltipTitleWrapper>
          }
          placement={tooltipPlacement}
        >
          <OverflowLength>+{overflowLength}</OverflowLength>
        </Tooltip>
      )}
    </div>
  );
};

export default TooltipOverflow;

const OverflowLength = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  margin-left: ${({ theme }) => theme.spacing(0.66)};
  cursor: default;
  letter-spacing: 1.5px;
  line-height: 1;
  opacity: 0.7;
`;

const TooltipTitleWrapper = styled.div(() => ({
  maxHeight: '60dvh',
  overflow: 'auto'
}));
